<div class="card">
	<div class="card-title card-title-label" translate>add-suborg.org-info</div>
	<div class="card-infos-block card-infos grid-6">
		<div class="card-info">
			<span class="card-info-label" translate>add-suborg.org-name</span>
			<div class="card-info-fields card-info-value">{{organizationName}}</div>
		</div>
		<div class="card-info">
			<span class="card-info-label" translate>add-suborg.vat-number</span>
			<div class="card-info-fields card-info-value">{{vatNumber}}</div>
		</div>
	</div>
	<div class="card-title card-title-label" translate>add-suborg.admin-info</div>
	<div class="card-infos-block card-infos grid-6">
		<div class="card-info">
			<span class="card-info-label" translate>add-suborg.firstname</span>
			<div class="card-info-fields card-info-value">{{userFirstName}}</div>
		</div>
		<div class="card-info">
			<span class="card-info-label" translate>add-suborg.lastname</span>
			<div class="card-info-fields card-info-value">{{userLastName}}</div>
		</div>
		<div class="card-info">
			<span class="card-info-label" translate>add-suborg.email</span>
			<div class="card-info-fields card-info-value">{{email}}</div>
		</div>
	</div>
</div>